import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import Login from './Login';
import BeBack from './BeBack';
import Settings from './Settings';
import LyftSettings from './LyftSettings';
import NoMatch from '../components/NoMatch';
import Logout from '../components/Logout';
import PrivateRoute from '../components/PrivateRoute';

const MainRouter = (props) => {
  const {
    currentWorkOrders,
  } = props;

  return (
    <Switch>
      <Route
        exact
        path='/'
        render={(rest) => <Login {...rest}/>}
      />
      <PrivateRoute
        path='/home'
        component={BeBack}
        {...props}
        currentWorkOrders={currentWorkOrders}
      />
      <PrivateRoute
        path='/settings'
        component={Settings}
        {...props}
      />
      <PrivateRoute
        path='/lyft-settings'
        component={LyftSettings}
        {...props}
      />
      <Route path='/logout' render={(rest) => <Logout {...rest} />} />
      <Route component={NoMatch} />
    </Switch>
  );
};

MainRouter.propTypes = {
  currentWorkOrders: PropTypes.array
};

export default MainRouter;